const dateformate = (isoStringDate) => {
  let readableDate = new Date(isoStringDate).toLocaleString("en-IN", {
    timeZone: "Asia/Kolkata",
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true, 
  });
  readableDate = readableDate.replace(/am|pm/, (match) => match.toUpperCase());

  return readableDate;
};


export default dateformate;
